import type { NHovExecutionState } from "./nHovExecutionAnimation";

export type NHovStagePanelId = "cells" | "nhov";

export class NHovStagePanelState {
  private panel: NHovStagePanelId = "cells";
  private nHovVisible = false;
  private nHovExecution: NHovExecutionState = null;

  get activePanel(): NHovStagePanelId {
    return this.panel;
  }

  get isNHovVisible(): boolean {
    return this.nHovVisible;
  }

  get isNHovExecuting(): boolean {
    return this.nHovExecution !== null;
  }

  get nHovExecutionState(): NHovExecutionState {
    return this.nHovExecution;
  }

  setNHovVisible(isVisible: boolean): void {
    this.nHovVisible = isVisible;
    if (!isVisible) {
      this.panel = "cells";
    }
  }

  setNHovExecutionState(state: NHovExecutionState): void {
    this.nHovExecution = state;
  }

  showCellsPanel(): void {
    this.panel = "cells";
  }

  showNHovPanel(): void {
    if (!this.nHovVisible) {
      return;
    }
    this.panel = "nhov";
  }
}
